export default {
    name: "cookies",

    set() { },
    get() { },
    remove() { },
    exists() { },
};
